import { ReactNode } from 'react';
import { VisualAsset } from 'core/flow/entities';
import { Button } from '../../Button';
import { VisualAssetImage } from '../../VisualAssetImage';

type ButtonOptionProps = {
  image?: VisualAsset;
  onClick: () => void;
  children?: ReactNode;
};

export const ButtonOption = ({ onClick, children, image, ...otherProps }: ButtonOptionProps) => {
  return (
    <Button
      fullWidth
      gutterBottom
      onClick={onClick}
      variant="option"
      startIcon={image && <VisualAssetImage image={image} width={24} height={24} />}
      {...otherProps}
    >
      {children}
    </Button>
  );
};
